import ClientForm from "./ClientForm";
import "./styles.scss";

export default { ClientForm };
